import {
  GetEstadoProceso,
  PostCalcularAlcancesContactCenter,
  PostPrecalculoContactCenter,
  PostCalcularComisionesContactCenter,
  PostCalcularAlcancesClub,
  PostPrecalculoClub,
  PostCalcularComisionesClub,
  DeleteRevertirAlcancesContactCenter,
  DeleteRevertirPrecalculoContactCenter,
  DeleteRevertirComisionesContactCenter,
  DeleteRevertirAlcancesClub,
  DeleteRevertirPrecalculoClub,
  DeleteRevertirComisionesClub,
  DeleteRevertirComisionesSemestral
} from "../../../reducers/comisionAnualidad";
import * as actions from "../../../actions/comisionAnualidad";
import { Preview } from "../../../../types/IAction";

export interface ProcesoAnualidadDispatcher {
  getEstadoProceso: (periodo: string) => Promise<Preview<GetEstadoProceso>>;
  postCalcularAlcancesContactCenter: (
    periodo: string
  ) => Promise<Preview<PostCalcularAlcancesContactCenter>>;
  postPrecalculoContactCenter: (
    periodo: string
  ) => Promise<Preview<PostPrecalculoContactCenter>>;
  postCalcularComisionesContactCenter: (
    periodo: string
  ) => Promise<Preview<PostCalcularComisionesContactCenter>>;
  postCalcularAlcancesClub: (
    periodo: string
  ) => Promise<Preview<PostCalcularAlcancesClub>>;
  postPrecalculoClub: (periodo: string) => Promise<Preview<PostPrecalculoClub>>;
  postCalcularComisionesClub: (
    periodo: string
  ) => Promise<Preview<PostCalcularComisionesClub>>;
  deleteRevertirAlcancesContactCenter: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirAlcancesContactCenter>>;
  deleteRevertirPrecalculoContactCenter: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirPrecalculoContactCenter>>;
  deleteRevertirComisionesContactCenter: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirComisionesContactCenter>>;
  deleteRevertirAlcancesClub: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirAlcancesClub>>;
  deleteRevertirPrecalculoClub: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirPrecalculoClub>>;
  deleteRevertirComisionesClub: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirComisionesClub>>;
  deleteRevertirComisionesSemestral: (
    periodo: string
  ) => Promise<Preview<DeleteRevertirComisionesSemestral>>;
}

export const procesoAnualidadDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ProcesoAnualidadDispatcher = dispatch => ({
  getEstadoProceso: (periodo: string) => {
    return dispatch(actions.getEstadoProceso(periodo));
  },
  postCalcularAlcancesContactCenter: (periodo: string) => {
    return dispatch(actions.postCalcularAlcancesContactCenter(periodo));
  },
  postPrecalculoContactCenter: (periodo: string) => {
    return dispatch(actions.postPrecalculoContactCenter(periodo));
  },
  postCalcularComisionesContactCenter: (periodo: string) => {
    return dispatch(actions.postCalcularComisionesContactCenter(periodo));
  },
  postCalcularAlcancesClub: (periodo: string) => {
    return dispatch(actions.postCalcularAlcancesClub(periodo));
  },
  postPrecalculoClub: (periodo: string) => {
    return dispatch(actions.postPrecalculoClub(periodo));
  },
  postCalcularComisionesClub: (periodo: string) => {
    return dispatch(actions.postCalcularComisionesClub(periodo));
  },
  deleteRevertirAlcancesContactCenter: (periodo: string) => {
    return dispatch(actions.deleteRevertirAlcancesContactCenter(periodo));
  },
  deleteRevertirPrecalculoContactCenter: (periodo: string) => {
    return dispatch(actions.deleteRevertirPrecalculoContactCenter(periodo));
  },
  deleteRevertirComisionesContactCenter: (periodo: string) => {
    return dispatch(actions.deleteRevertirComisionesContactCenter(periodo));
  },
  deleteRevertirAlcancesClub: (periodo: string) => {
    return dispatch(actions.deleteRevertirAlcancesClub(periodo));
  },
  deleteRevertirPrecalculoClub: (periodo: string) => {
    return dispatch(actions.deleteRevertirPrecalculoClub(periodo));
  },
  deleteRevertirComisionesClub: (periodo: string) => {
    return dispatch(actions.deleteRevertirComisionesClub(periodo));
  },
  deleteRevertirComisionesSemestral: (periodo: string) => {
    return dispatch(actions.deleteRevertirComisionesSemestral(periodo));
  }
});
